import React, { Fragment, useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import "../../../../template/App.css";
import { useEffect } from "react";
import { skillService } from "../../../../services/profile";
import SkillDialogForm from "./skill_form";
import { toast } from "react-toastify";
import { confirmDialog } from "primereact/confirmdialog";
import { Tooltip } from 'primereact/tooltip';

function ProfileSkill({ userSkills, onRefresh, profileUserId }) {
  const [skillDialog, setSkillDialog] = useState(false);
  const [skillData, setSkillData] = useState([]);
  const [skillListData, setSkillListData] = useState([]);

  useEffect(() => {
    setSkillListData(userSkills);
  }, [userSkills])

  const onHide = () => {
    setSkillDialog(false);
  };
  const saveData = (data) => {
    var skillListing = [];
    data.skills.map((item) => {
      let objProject = { skillId: item.id };
      skillListing.push(objProject);
    });
    let param = { userId: profileUserId ? profileUserId : "", skillListing, };
    try {
      skillService.addBulkSkills(param).then((resp) => {
        onRefresh();
        setSkillDialog(false);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const addSkillData = () => {
    get_skills();
    setSkillDialog(true)
  }

  const get_skills = () => {
    skillService.getSkills().then((resp) => {
      setSkillData(resp.data.data);
    });
  };

  /* Dialog Box for Add/Edit Form Start */
  const AddSkillDialog = () => {
    return (
      <Dialog header="Add Skills" visible={skillDialog} style={{ width: "500px" }} onHide={() => onHide()}>
        <SkillDialogForm save={(data) => saveData(data)} onClose={(e) => { setSkillDialog(false); }} skillData={skillData} />
      </Dialog>
    );
  };
  /* Dialog Box for Add/Edit  Form End */

  const deleteSkill = (id) => {
    confirmDialog({
      message: "Do you want to delete this record?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      acceptLabel: 'No',
      rejectLabel: 'Yes',
      accept: () => { },
      reject: () => {
        skillService.deleteSkill(id).then((resp) => {
          onRefresh();
          toast.success("Skill deleted successfully")
        })
      },
    });
  };

  const addSkill = (id) => {
    confirmDialog({
      message: "Add as a Primary skill",
      header: "Primary Skill",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      acceptLabel: 'Yes',
      rejectLabel: 'No',
      accept: () => updateSkillById(id),
      reject: () => { }
    });
  };

  const updateSkillById = (id) => {
    let param = {
      id: id,
      primarySkills: true,
      primarySkillRating:1,
      userId: profileUserId ? profileUserId : "",
    };
    try {
      skillService.updateSkill(param).then((resp) => {
        onRefresh();
        toast.success("Added as Primary skill");
        setSkillDialog(false);
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Fragment>
      {skillListData && (
        <>
          {AddSkillDialog()}
          <div className="wrapper p-3">
            <div className="grid">
              <div className="col">
                <span className="heading">
                  Skills
                  <div className="heading-actions">
                    <Button label="Add" disabled className="p-button-text" />
                    <Button icon="pi pi-plus" type="button" onClick={() => addSkillData()} className="p-button-rounded p-button circle" aria-label="Add" />
                  </div>
                </span>
              </div>
            </div>

            <div className="align-items-center flex-wrap p-1 btn_wrapper">
              {skillListData.map((item, i) => (
                <>
                  {item?.Skill != null && (
                    <Button key={"skillListData" + i} type="button" label={item?.Skill?.title} className="p-button-rounded p-button-secondary mr-2 mb-2">
                      <Tooltip target=".pi-plus" position="top" >
                        <label>Add as a Primary Skill</label>
                      </Tooltip>
                      <i className="pi pi-plus" style={{ fontSize: "1.2rem", marginLeft: "10px", color: "Chartreuse" }}
                        onClick={() => { addSkill(item.id); }}
                      ></i>
                      <i className="pi pi-times-circle" style={{ fontSize: "1.2rem", marginLeft: "10px" }} onClick={() => { deleteSkill(item.id); }}
                      ></i>
                    </Button>
                  )}
                </>
              ))}
            </div>
          </div>
        </>
      )}
    </Fragment>
  );
}

export default ProfileSkill;